import React, { useState, useLayoutEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import '../css/pages_styles.css';
import backgroundImage from '../assets/background.png';

const Discussion = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(false); // ⬅️ 預設收起

  /* --- 螢幕尺寸監聽 (同步) --- */
  useLayoutEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const handleMatch = (e) => setIsMobile(e.matches);

    handleMatch(mq);                     // 初始判斷
    mq.addEventListener('change', handleMatch);
    return () => mq.removeEventListener('change', handleMatch);
  }, []);

  /* --- 進頁面時保證 Sidebar 收起 (再次保險) --- */
  useLayoutEffect(() => {
    setSidebarExpanded(false);
  }, []);

  /* --- Sidebar onToggle --- */
  const handleSidebarToggle = (expanded) => setSidebarExpanded(expanded);

  /* --- 行動版才需要遮罩 --- */
  const showOverlay = sidebarExpanded && isMobile;

  return (
    <div style={{ display: 'flex', position: 'relative' }}>
      {/* 遮罩（點擊即可收起 Sidebar） */}
      {showOverlay && (
        <div
          className="overlay"
          onClick={() => setSidebarExpanded(false)}
        />
      )}

      <Sidebar onToggle={handleSidebarToggle} />

      <div
        className="main-content"
        style={{
          marginLeft: isMobile ? '0' : sidebarExpanded ? '250px' : '0',
          transition: 'none', // 移除過渡動畫
        }}
      >
        <div className="container">
          <header 
            className="header"
            style={{backgroundImage: `url(${backgroundImage})`}}
          >
            <h1 className="title">跨域論壇</h1>
          </header>

          {/* ——— Speaker 1 ——— */}
          <div className={`speaker-wrapper ${isMobile ? 'speaker-wrapper-mobile' : ''}`}>
            <div className={`speaker-content ${isMobile ? 'speaker-content-mobile' : ''}`}>
              <div className="speaker-image-container">
                <img
                  src={require('../assets/張嘉淵.png')}
                  alt="張嘉淵 博士"
                  className={`speaker-image ${isMobile ? 'speaker-image-mobile' : ''}`}
                />
              </div>
              <div className="speaker-info">
                <h2 className="speaker-name">張嘉淵 廣達電腦 技術長</h2>
                <ul className="speaker-bio-list">
                  <li><strong>學歷：</strong>成功大學航空太空工程研究所 學士 '88, 碩士 '92, 博士 '96</li>
                  <li><strong>現職：</strong>廣達電腦 技術長暨副總經理、廣達研究院 院長</li>
                  <li><strong>重要經歷：</strong>
                    <ul>
                      <li><strong>APEC企業諮詢委員會(ABAC)：</strong>
                        <ul>
                          <li>2025 生技與健康工作小組 副主席 BHWG/ABAC2025</li>
                          <li>2024 人才與技能數位轉型優先領域召集人 HDWG/ABAC2024</li>
                          <li>2023 數位創新工作小組 DAIY計畫主持人 DIWG/ABAC2023</li>
                          <li>2022 數位工作小組 共同主席 DWG/ABAC2022</li>
                          <li>2021 支持新興科技小組 共同召集人 DWG/ABAC2021</li>
                          <li>2019~ 總統任命 中華民國代表</li>
                        </ul>
                      </li>
                      <li><strong>教學職務：</strong>
                        <ul>
                          <li>2021~ 國立台灣大學 電機資訊學院網媒所 客座教授</li>
                          <li>2021~ 國立成功大學 電機資訊學院資訊系 客座教授</li>
                          <li>2020~ 國立陽明交通大學 智慧科學暨綠能學院 合聘教授</li>
                          <li>2021~ 私立亞洲大學 電機資訊學院資訊系 兼任講座教授</li>
                        </ul>
                      </li>
                      <li><strong>研發計畫：</strong>
                        <ul>
                          <li>廣達電腦-麻省理工學院 電腦科學暨人工智慧實驗室MIT CSAIL 計劃主持人 (Since 2004)</li>
                          <li>TParty (2004~2010), Qmulus (2010~2018), AI Medicine (2019~2024), Project AIR (2024~)</li>
                        </ul>
                      </li>
                      <li><strong>董事職務：</strong>
                        <ul>
                          <li>時代基金會</li>
                          <li>文化內容策進院</li>
                          <li>中華醫藥促進基金會</li>
                          <li>廣達醫療科技基金會</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li><strong>榮譽與獎項：</strong>
                    <ul>
                      <li>2024 IEEE 科技產業人道貢獻獎</li>
                      <li>2024 MIT CSAIL Visionary Partner Award (廣達研究院)</li>
                      <li>2024/2022/2021 德國紅點設計獎 Red Dot Design Award (六座)</li>
                      <li>2024/2022/2021/2019/2018/2017 廣達電腦最佳設計專利金牌獎 (六座)</li>
                      <li>2022 日本Good Design Best 100 Award 百大設計獎 (OpenTix)</li>
                      <li>2021 國立成功大學 傑出校友獎</li>
                      <li>2021 國立嘉義中學 傑出校友獎</li>
                      <li>2021 德國IF設計獎 IF Design Award (Smart Agriculture)</li>
                      <li>2020 CES Innovation Award (廣達交大聯合AI中心)</li>
                      <li>2020 世界資訊科技與服務聯盟 WITSA－PPP Silver Award</li>
                      <li>全球超過兩百七十件設計與發明專利授證 (by 2024/11)</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* ——— Speaker 2 ——— */}
          <div className={`speaker-wrapper ${isMobile ? 'speaker-wrapper-mobile' : ''}`}>
            <div className={`speaker-content ${isMobile ? 'speaker-content-mobile' : ''}`}>
              <div className="speaker-image-container">
                <img
                  src={require('../assets/李韶曼.png')}
                  alt="教授2"
                  className={`speaker-image ${isMobile ? 'speaker-image-mobile' : ''}`}
                />
              </div>
              <div className="speaker-info">
                <h2 className="speaker-name">李韶曼 國立成功大學 助理教授</h2>
                <p className="speaker-bio">李韶曼為國立成功大學敏求智慧運算學院及心理學系合聘助理教授，並為國際公法學會台灣分會執行秘書、全國律師聯合會第2屆人工智慧發展與應對委員會顧問。
                李韶曼於國立臺灣大學取得法學士及法學碩士學位，隨後赴美深造，於美國耶魯大學法學院獲得法學碩士學位，並進一步於美國加州大學柏克萊分校取得法學博士學位。主要研究領域涵蓋法律科技、法律實證研究、以及人工智慧法律與治理議題。</p>
              </div>
            </div>
          </div>
          
          {/* ——— Speaker 3 ——— */}
          <div className={`speaker-wrapper ${isMobile ? 'speaker-wrapper-mobile' : ''}`}>
            <div className={`speaker-content ${isMobile ? 'speaker-content-mobile' : ''}`}>
              <div className="speaker-image-container">
                <img
                  src={require('../assets/溫怡玲.png')}
                  alt="教授3"
                  className={`speaker-image ${isMobile ? 'speaker-image-mobile' : ''}`}
                />
              </div>
              <div className="speaker-info">
                <h2 className="speaker-name">溫怡玲 財團法人人工智慧科技基金會 執行長</h2>
                <p className="speaker-bio">
                  現任財團法人人工智慧科技基金會執行長、《知勢》電子報總編輯、IC之音節目主持人。
                </p>
                <p className="speaker-bio">
                  曾任職多家財經媒體，橫跨電視、雜誌與網路媒體，並擔任多所大學及組織講師。2018年進入人工智慧領域，負責台灣人工智慧學校營運及知識社群經營，2020年接任基金會執行長迄今。
                </p>
                <p className="speaker-bio">
                  2019年與已故台灣人工智慧學校執行長陳昇瑋博士合著《人工智慧在台灣：產業轉型的契機與挑戰》，是第一本從台灣產業角度出發、橫跨技術與實際應用，探討人工智慧對於產業轉型影響的書籍。
                </p>
                <p className="speaker-bio">
                  2021年底出版與台經院景氣預測中心主任孫明德博士合著《孫主任的經濟筆記》，結合總體經濟學重要指標與時事，深入淺出分析中美貿易戰及疫情之後，全球與台灣經濟的可能走向和關鍵變數。
                </p>
                <p className="speaker-bio">
                  2023年6月底出版與《親子天下》編輯團隊合著《AI如何重塑教育》。
                </p>
              </div>
            </div>
          </div>

          {/* ——— Speaker 4 ——— */}
          <div className={`speaker-wrapper ${isMobile ? 'speaker-wrapper-mobile' : ''}`}>
            <div className={`speaker-content ${isMobile ? 'speaker-content-mobile' : ''}`}>
              <div className="speaker-image-container">
                <img
                  src={require('../assets/李育杰.png')}
                  alt="教授4"
                  className={`speaker-image ${isMobile ? 'speaker-image-mobile' : ''}`}
                />
              </div>
              <div className="speaker-info">
                <h2 className="speaker-name">Prof. Yuh-Jye Lee, Research Center for Information Technology Innovation</h2>
                <p className="speaker-bio">Prof. Yuh-Jye Lee is a computer scientist who holds a PhD in Computer Sciences from UW-Madison (2001). He has held positions at esteemed universities, including National Chun Cheng University, Taiwan Tech, and National Yang Ming Chiao Tung University.</p>
                <p className="speaker-bio">Prof. Lee also had the opportunity to serve the government from November 2020 to January 2023 as the Deputy Executive Secretary of the Office of Science and Technology Policy, National Science and Technology Council. This office is responsible for Taiwan's science and technology policies, budget allocation, and the review of national-level science and technology projects.  He serves as the Chief Executive Officer of the Taiwan Information Security Center at the Research Center for Information Technology Innovation (CITI), Academia Sinica in the period of Aug. 2023 to Feb. 2024 and Sept. 2018 to Feb. 2021. Now he is a research fellow at CITI.</p>
                <p className="speaker-bio">Prof. Lee's research primarily focuses on AI, data science, machine learning, federated learning, and information security, with a specific interest in developing lightweight anomaly detection techniques for IoT applications. Over the past decade, he has developed numerous efficient machine learning algorithms such as SSVM and RSVM that have been successfully applied in various fields, including breast cancer diagnosis and prognosis, network intrusion detection, and fake news prevention. In essence, his research is centered on AI in security and security in AI. He is also in charge of the TAIDE project, which stands for Trustworthy AI Dialogue Engine.</p>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Discussion;

